import React, {Component} from 'react'


import SettingsGroup from '../../../struct/SettingsGroup'
import RegionSettings from './RegionSettings'
import Hint from '../../../struct/Hint'

import styles from './ShippingPaymentSettings.less'
import Iconui from 'lib/struct/iconui/Iconui';

const regions = [
    {
        id: '213',
        name: 'Москва',
        stocks_option: 'DEFAULT',
        stocks_ids: [],
        home_region: true,
        payment_methods: ['prepaid']
    },
    {
        id: '66',
        name: 'Екб',
        stocks_option: 'DEFAULT',
        stocks_ids: [],
        payment_methods: ['prepaid']
    }
]

const newRegionTemplate = {
    id: 'new',
    name: 'Создание группы регионов',
    stocks_option: 'DEFAULT',
    stocks_ids: [],
    payment_methods: ['prepaid'],
    days: [false, true, true, true, true, true, false],
    pvzList: [],
    courierAllowed: false,
    pickupAllowed: false,
    courierFromDate: '1',
    courierToDate: '2',
    courierOrderTime: '14:00'
}


const {
    'add-block': addBlock,
    'error-status': errorStatus
} = styles

export default class ShippingPaymentSettings extends Component {
    constructor(props) {
        super(props)
        props.campaign.regions = 'regions' in props.campaign ? props.campaign.regions : []
        this.state = {
            activeRegionId: null,
            isCreateRegionBlock: false,
            newRegion: false,
            addNewRegion: false,
            statusText: ''
        }
    }

    onSelectRegion = (id) => {
        const {activeRegionId} = this.state
        let newActiveRegionId = null

        if (activeRegionId !== id) {
            newActiveRegionId = id
        }

        this.setState({activeRegionId: newActiveRegionId, isCreateRegionBlock: false})
    }

    onDeleteRegion = (id) => {
        this.props.campaign.regions = this.props.campaign.regions.filter((_, i) => _.id !== id)

        this.props.context.regions_to_delete.push(id)
        this.setState({
            isCreateRegionBlock: false
        })
    }

    openCreateRegion = () => {
        this.setState({
            isCreateRegionBlock: true,
            activeRegionId: 'new',
            newRegion: Object.assign({}, newRegionTemplate)
        })
        this.props.context.is_create_region = true;
        this.props.context.saveRegion = this.addNewRegion.bind(this);
    }

    addNewRegion = () => {

        if (this.state.newRegion.settings.regions.length > 0) {
            this.props.campaign.regions.push(this.state.newRegion)
            const index = this.props.campaign.regions.length - 1
            this.props.campaign.regions[index]['id'] += index
            this.setState({
                isCreateRegionBlock: false,
                activeRegionId: this.props.campaign.regions[index]['id'],
                newRegion: false
            })
            this.props.context.is_create_region = false;
        } else {
            this.setState({
                statusText: 'Не выбран ни один регион'
            })
            setTimeout(() => {
                this.setState({
                    statusText: ''
                })
            }, 2000)
        }
    }

    render() {
        const {campaign, context} = this.props

        return (
            <SettingsGroup title={'6. Настройки доставки и оплаты'}>
                <Hint className={styles['hintHeader']}>{'Создайте регионы и укажите для них условия по доставке и оплате. Информация должна совпадать с настройками в личном кабинете Яндекс.Маркет.'}</Hint>
                {campaign.regions.length > 0 ? campaign.regions.map((region, i) => (<RegionSettings
                        region={region}
                        isActive={region.id === this.state.activeRegionId}
                        isHome={region.home}
                        onSelectRegion={this.onSelectRegion}
                        onDeleteRegion={this.onDeleteRegion}
                        context={context}
                        campaign={campaign}
                        key={region.id}
                    />))
                    : null}
                {this.state.isCreateRegionBlock ?
                    (<RegionSettings
                        region={this.state.newRegion}
                        isActive={this.state.newRegion.id === this.state.activeRegionId}
                        isNew={true}
                        context={context}
                        campaign={campaign}
                    />)
                    : null}
                <div className={addBlock}>
                    {this.state.isCreateRegionBlock ?
                        <div>
                            <button className="button green" onClick={this.addNewRegion}>
                                Сохранить группу
                            </button>
                            <span className={errorStatus}>{this.state.statusText}</span>
                        </div>
                        :
                        <a onClick={this.openCreateRegion}>
                            <Iconui name={'add'} />Добавить регион...
                        </a>
                    }
                </div>
            </SettingsGroup>
        )
    }
}